import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchLogs(_, params) {
      return axiosIns.get('/trails', {
        params,
      })
    },
  },
}
